<template>
  <div class="animated fadeIn list-of-tranbank">
    <b-card>
      <div slot="header">REPORT CASH/BANK TRANSACTION LIST 
        <div class="card-header-actions">
          <button class="btn btn-primary mr-1" @click="togleFilter()">
            <i class="fa fa-filter"></i> Filter
          </button>
          <button class="btn btn-primary mr-1" @click="printjv()">
              <i class="fa fa-print"></i> Print JV
          </button>
         <button class="btn btn-primary mr-1" @click="exportxls()">
              <i class="fa fa-file-excel-o"></i>
              Export
          </button>
          <button class="btn btn-primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
        </div>
      </div>
      <b-row v-if="showFilter">
        <b-col lg="6">
          <b-input-group >
            <b-input-group-prepend><label>Dimension Name</label></b-input-group-prepend>
            <b-form-select v-model="tblData.DimCol" :plain="true" :options="dimension"></b-form-select>
            <b-input-group-prepend><span class="input-group-text">value</span></b-input-group-prepend>
            <b-form-input v-model="tblData.DimVal" placeholder="Dimension Value"></b-form-input>
          </b-input-group>
          <b-input-group >
            <b-input-group-prepend><label>Trx. Date</label></b-input-group-prepend>
            <b-form-input v-model="tblData.tgl1" type="date" ></b-form-input>
            <b-input-group-prepend><span class="input-group-text">until</span></b-input-group-prepend>
            <b-form-input v-model="tblData.tgl2" type="date" ></b-form-input>
          </b-input-group>
        </b-col>
        <b-col lg="6">
          <b-row>
            <b-col lg="7">
                <b-input-group >
                  <b-input-group-prepend><label>Cash/bank Account</label></b-input-group-prepend>
                  <b-form-input v-model="tblData.namaacc" @change="tblData.kodebank=''" placeholder="Finance Bank Code"></b-form-input>
                  <b-input-group-append>
                      <b-btn text="Button" @click="lkuBankaccountShow=true">
                          <i class="fa fa-search"></i>
                      </b-btn>
                  </b-input-group-append>
                </b-input-group>                  
            </b-col>
            <b-col lg="5"><b-form-input v-model="tblData.kodeacc" placeholder="Accounting Code"></b-form-input></b-col>
          </b-row>                      
          <b-input-group >
            <b-input-group-prepend><label >Pay/Receipt Group</label></b-input-group-prepend>
              <b-form-select v-model="tblData.trxgroup" :plain="true" :options="trxgroups" style="width:25% !important;"></b-form-select>
              <b-form-select v-model="tblData.iogroup" :plain="true" :options="['','All Payment','All Receipt']" class="ml-1"></b-form-select>
            <b-input-group-append>
                <b-button class="btn btn-success ml-3" @click="search()" > <i class="fa fa-refresh"></i> Apply Filter</b-button>
            </b-input-group-append>
            <b-input-group-append>
              <b-button class="btn btn-secondary ml-1" @click="clearFilter()" > <i class="fa fa-eraser"></i>Clear Filter</b-button>
            </b-input-group-append>
          </b-input-group>
        </b-col>
      </b-row>
      <b-table
        class="mb-0"
        ref="table"
        outlined
        responsive striped hover small
        style="font-size:smaller;" 
        :items="data"
        :fields="tblFields"
        :current-page="tblData.page"
        :per-page="tblData.limit"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
        :key="tblData.limit"  @row-clicked="rowClicked" 
      >
        <template v-slot:cell(tanggal)="data">
          {{ data.item.tanggal | moment("DD MMM YYYY") }}
        </template>
        <template v-slot:cell(kodeacc)="data">
          {{data.item.kodeacc}} | {{data.item.namabank}}
        </template>
        <template v-slot:cell(original)="data">
          <span v-if="data.item.poststatus==0" style="background-color:yellow;">           
            {{data.item.matauang}}
            {{(data.item.valas_in+data.item.valas_out)|numFormat}}
          </span>
          <span v-else> 
            {{data.item.matauang}}
            {{(data.item.valas_in+data.item.valas_out)|numFormat}}
          </span>
        </template>
        <template v-slot:cell(bank_in)="data">
          {{data.item.bank_in|numFormat}}
        </template>
        <template v-slot:cell(bank_out)="data">
          {{data.item.bank_out|numFormat}}
        </template>

      </b-table>
      <b-row class="mt-2">
        <b-col cols="4">
          <div>
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
          </div>
        </b-col>
        <b-col cols="4" >
            <b-form-group label-cols=3 label="Limit per page"  style="margin-top:0 !important;">
            <b-form-select :options="[10, 20, 30, 50, 70, 90, 120]" :plain="true" v-model="tblData.limit"  size="sm" style="width:80px;"/>
            </b-form-group>
        </b-col>        
        <b-col cols="4">            
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
    </b-card>
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
    <b-modal v-model="showReport" size="xl" scrollable title="Preview as PDF" ok-only>
        <iframe v-if="reportUrl" :src="reportUrl" frameborder="0"></iframe>
    </b-modal>
    <b-modal v-model="lkuBankaccountShow" size="lg" :hide-footer="true" title="List of Bank/Cash Account" :centered="true">
        <lku-bankaccount @click="onSelectLkuBankaccount" :formdata="lkuBankaccountData"></lku-bankaccount>
    </b-modal>        

  </div>
</template>

<style lang="scss">
    .list-of-tranbank {
      table {
        td:nth-child(1) {
          width: auto;
        }
        td:nth-child(2) {
          width: 120px;
        }
      }
    }
 
</style>


<script>
import moment from 'moment';
import tranbank from "../../apis/tranbank";
import lkuBankaccount from "../lookup/lkuBankaccountLazzy";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import toastr from "mini-toastr";
toastr.init();

export default {
  data() {
    return {
      uanguser:this.$store.state.user.matauang,
      showFilter: true,
        lkuBankaccountData:{},
      lkuBankaccountShow:false,
      isLoading:false,
      showReport:false,
      reportUrl: null,
      tblData: {
        items: [],
        page: 1,
        limit: 15,
        total: 0,
        
        sortBy: 'tanggal',
        sortDesc: true,DimCol:'', iogroup:'', trxgroup:''
      },
      bankCashAcc: [],
      trxgroups : [{ value: '', text: '--- ALL ---'},
        { value: 'AR Payment', text: 'AR Payment Receipt' },
        { value: 'Sales PrePayment', text: 'Sales PrePayment Receipt' },
        { value: 'Adv.Settlement-Return', text: 'Adv.Settlement-Excess Cash' },
        { value: 'AP Payment', text: 'AP Payment' },
        { value: 'Cash Advance Payment', text: 'Cash Advance Payment' },
        { value: 'Adv.Settlement-Addition', text: 'Adv.Settlement-Excess Expense' },
        { value: 'Expense Reimburs', text: 'Expense Reimbursment Payment' },
        { value: 'Transfer Inter Account', text: 'Transfer Inter Account' },
        { value: 'Other Receipt', text: 'Other Receipt' },
        { value: 'Other Payment', text: 'Other Payment' } 
      ]     
    };
  },
  components: { Loading, lkuBankaccount},
  computed: {
    dimension(){
      return this.$store.state.dimension;
    },
    dimCol() {
        return this.tblData.DimCol;
    },
    tblFields(){
      const fields=[
          {
            key: "nomor",
            thStyle: "width:100px",
            label: "Trx. Number",
            sortable: true
          },
          {
            key: "kodeacc",
            label: "Account",
            thStyle: "width:200px",
            sortable: true
          },
          {
            key: "tanggal",
            thStyle: "width:70px",
            label: "Trx. Date",
            sortable: true
          },
          {
            key: "uraian",
            label: "Description",
            sortable: true
          },
          {
            key: "terimadari",
            label: "to/from",
            sortable: true
          },
          {
            key: "paymethod",
            label: "Pay Method",
            sortable: true
          },
          {
            key: "matauang",
            thStyle: "width:40px",
            label: "$,¥",
            sortable: true
          },
        {
          key: "original",
          label: "Original Amt.",
          thStyle: "width:100px",
          thClass: "text-right",
          tdClass: "text-right",
          sortable: true
        },
        {
          key: "bank_in",
          label: `Debit (${this.uanguser})` ,
          thStyle: "width:100px",
          thClass: "text-right",
          tdClass: "text-right",
            sortable: true
        },
        {
          key: "bank_out",
          label: `Credit (${this.uanguser})`,
          thStyle: "width:100px",
          thClass: "text-right",
          tdClass: "text-right",
            sortable: true
        },
          {
            key: "trxgroups",
            label: "Transaction Group",
            sortable: true
          },
        ];
        const dims = this.$store.state.dimension;
        for (let i = 0; i < dims.length; i += 1) {
          fields.push(          {
            key: `${dims[i].value}Txt`,
            thStyle: "width:100px",
            label: dims[i].text,
            sortable: true
          },)
        }
      return fields;
    }
  },
  watch:{
        dimCol: function(newval) {
            this.tblData.DimVal="";
            this.tblData.DimValInfo="";
            this.tblData.DimColInfo=this.dimension.find(d => d.value === newval).text;
        },
        "tblData.iogroup": function(newval) {
          if (newval) {
            this.tblData.trxgroup="";
          }
        },
        "tblData.trxgroup": function(newval) {
          if (newval) {
            this.tblData.iogroup="";
          }
        }
  },  
  created: async function(){
        const tgl2 = moment(this.$store.state.user.tglaktif, 'YYYY-MM-DD').add(1,'M').subtract(1, 'day');
        this.tblData.tgl1=this.$store.state.user.tglaktif;
        this.tblData.tgl2=tgl2.format('YYYY-MM-DD');
  },  
  methods: {
    onSelectLkuBankaccount(lkuData) {
        this.lkuBankaccountData=lkuData;
        this.lkuBankaccountShow=false;
        this.tblData.kodebank=lkuData.selected.kode;
        // this.tblData.kodeacc=lkuData.selected.kodeacc;
        // this.model.matauang=lkuData.selected.matauang;
        this.tblData.namaacc=lkuData.selected.namabank;
        // this.model.nomorrek=lkuData.selected.nomorrek;
        // this.model.isbank=lkuData.selected.isbank;
        this.lkuBankaccountShow=false;
    },    
    onFiltered(filteredItems) {
      this.tblData.total = filteredItems.length;
    },
    data: async function(ctx) {
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";

      const list = await tranbank.rptlist(this.tblData);      
      return list;
    },
    togleFilter() {
      this.showFilter=!this.showFilter;
    },
    refresh(ctx) {
      this.$refs.table.refresh();
    },
    search(ctx) {
      this.tblData.page=1;
      this.refresh();
    },
    clearFilter(ctx) {
        this.tblData.kodeacc= '';
        this.tblData.namaacc=  '';
        this.tblData.kodebank=  '';
        // this.tblData.nomor=  '';
        this.tblData.trxgroup=  '';
        this.tblData.iogroup=  '';
        this.tblData.tgl1=  '';
        this.tblData.tgl2=  '';
        this.tblData.DimVal=  '';
        this.refresh();
    },
    rowClicked(record, index) {
      if ((this.model) && (this.model._rowVariant)) {
          delete this.model._rowVariant;
      }
      this.model = record;
      record._rowVariant= 'info';
      this.$forceUpdate();
    },
    printjv: async function()
    {
      if (this.model) {
          this.isLoading=true;
          try {
              this.showReport=true;
              this.reportUrl= await tranbank.printjv(this.model);
              this.isLoading=false;
          } catch (error) {
              this.isLoading=false;
              if (error.message) {
                  toastr.error(error.message);
              } else {
                  toastr.error(JSON.stringify(error));
              }
          }
        } else {
            toastr.warn('Please select a row that want to be Printed!');
        }

    },
    exportxls: async function() {
        this.isLoading=true;
        try {
            const response = await tranbank.rptexport(this.tblData);
            this.isLoading=false;    
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message);
            } else {
                toastr.error(JSON.stringify(error));
            }
        }
    },    
    close(){
        router.push({name:'treasury.home'});
    }
  }
};
</script>
